import BaseViewModel from './BaseViewModel';

class BoolControlViewModel extends BaseViewModel {
	ValidateMandatory = () => {
		return !this.IsMandatory || this.getValue() !== undefined;
	};

	override getValue = () => {
		return !!this.Value;
	};

	override getSimpleFormatXmlTagName = () => {
		return 'Bool';
	};
}

export default BoolControlViewModel;
